import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import * as MenuListUI from 'components/MenuList';
import PopoverCard from 'components/PopoverCard';
import { useNavMenuContext } from './NavMenu';
function NavMenuList(_ref) {
  var children = _ref.children;
  var _useNavMenuContext = useNavMenuContext(),
    popover = _useNavMenuContext.popover,
    itemList = _useNavMenuContext.itemList;
  return /*#__PURE__*/React.createElement(PopoverCard, _extends({
    renderInPlace: true,
    renderWhenClosed: true,
    isOpen: popover.isOpen
  }, popover.props, {
    ref: popover.setRef,
    id: itemList.listId,
    arrow: popover.arrow
  }), /*#__PURE__*/React.createElement(MenuListUI.Wrapper, null, children));
}
export default NavMenuList;